import { render } from "./TeamCardSection.vue?vue&type=template&id=509d9d19"
import script from "./TeamCardSection.vue?vue&type=script&lang=js"
export * from "./TeamCardSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__